import {
  DEFAULT_FILTER_MODEL_STATE,
  useDataGridContext,
} from '@issuemanager/apps/client/components';
import { useUserContext } from '@issuemanager/apps/client/contexts';
import { ToBeApprovedDto } from '@issuemanager/api-client';
import { useTranslation } from 'react-i18next';
import { ApproverColumnFilter } from '@issuemanager/client/features/issues';
import {
  ISSUE_FIELD_ACTION_APPROVER,
  ISSUE_FIELD_APPROVER,
  ToBeApprovedTypeEnum,
} from '@issuemanager/constants';
import {
  QuickFilterAllEnum,
  ToBeApprovedEnum,
} from '@issuemanager/test/constants';
import { QuickFilterItem } from './quick-filter-item';
import { QuickFilterContainer } from './quick-filter-container';

export function ToBeApproved({
  toBeApproved,
  activeFilter,
  setActiveFilter,
}: {
  toBeApproved: ToBeApprovedDto | undefined;
  activeFilter: QuickFilterAllEnum | null;
  setActiveFilter: (value: QuickFilterAllEnum) => void;
}) {
  const context = useDataGridContext();
  const user = useUserContext();
  const { t } = useTranslation('issue');

  const clearFilters = () => {
    context.setFilterModel(DEFAULT_FILTER_MODEL_STATE);
  };

  const handleFilterSelection = (type: string) => {
    clearFilters();
    switch (type) {
      case ToBeApprovedTypeEnum.ISSUES_TO_APPROVE:
        context.setColumnVisibilityModel((prevState) => ({
          ...prevState,
          [ISSUE_FIELD_APPROVER]: true,
        }));
        context.setFilterModel(
          (prevState) => ({
            ...prevState,
            [ISSUE_FIELD_APPROVER]: [
              {
                ...user.data,
                group: ApproverColumnFilter.ISSUE_APPROVER,
              },
            ],
          }),
          'quick-filter',
        );
        break;
      case ToBeApprovedTypeEnum.ACTIONS_TO_APPROVE:
        context.setColumnVisibilityModel((prevState) => ({
          ...prevState,
          [ISSUE_FIELD_APPROVER]: true,
        }));
        context.setFilterModel(
          (prevState) => ({
            ...prevState,
            [ISSUE_FIELD_ACTION_APPROVER]: [
              {
                ...user.data,
                group: ApproverColumnFilter.ACTION_APPROVER,
              },
            ],
          }),
          'quick-filter',
        );
        break;
    }
  };

  return (
    <QuickFilterContainer label={t('quickFilters.toBeApproved.title')}>
      <QuickFilterItem
        label={t('quickFilters.toBeApproved.issues')}
        number={toBeApproved?.issuesToApprove}
        onClick={() => {
          handleFilterSelection(ToBeApprovedTypeEnum.ISSUES_TO_APPROVE);
          setActiveFilter(ToBeApprovedEnum.ISSUES_TO_APPROVE);
        }}
        isActive={activeFilter === ToBeApprovedEnum.ISSUES_TO_APPROVE}
      />
      <QuickFilterItem
        label={t('quickFilters.toBeApproved.actions')}
        number={toBeApproved?.actionsToApprove}
        onClick={() => {
          handleFilterSelection(ToBeApprovedTypeEnum.ACTIONS_TO_APPROVE);
          setActiveFilter(ToBeApprovedEnum.ACTIONS_TO_APPROVE);
        }}
        isActive={activeFilter === ToBeApprovedEnum.ACTIONS_TO_APPROVE}
      />
    </QuickFilterContainer>
  );
}
